<template>
  <div id="mz-audio" class="mz-audio">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <div
      class="audio-wraper"
      :class="{ 'modal-ui-active': modalActive }"
      :style="$store.getters.showIcons ? 'align-items: flex-end;' : ''"
    >
      <div ref="audio" class="audio">
        <audio id="playerAudio" title controls crossorigin playsinline>
          <source :src="audioFile" type="audio/ogg" />
          <source :src="audioFile" type="audio/mpeg" :key="componentKey" />
          Your browser does not support the audio element.
        </audio>
        <div class="audio-title">
          <span v-html="audioTitle">{{ audioTitle }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Plyr from 'plyr';

import { getAudioURL } from '__mainSrcDir/Utils/DB/get';
import { AUDIO_NAMES } from '__mainSrcDir/Utils/DB/configDB';
// import store from '../../../../store';
export default {
  name: 'mz-audio',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      audioTitle: '',
      audioFile: '',
      componentKey: true,
    };
  },
  mounted() {
    this.audioTitle = this.startGameConfig.audioTitle;
    console.log('MOUNT AUDIO');
    const controls = ['play', 'restart', 'progress', 'current-time', 'mute', 'volume', 'settings'];
    this.player = new Plyr('#playerAudio', { controls });
    if (process.env.VUE_PWA) {
      console.log('PWA working');
      options.mp3 = require(`__staticDir/${this.$store.getters.multibookType}/${this.startGameConfig.audioSrc}`);
      console.log('options', options);
      this.changeAudio(options.mp3);
    } else {
      this.setSource(this.startGameConfig.audioSrc);
    }
  },
  methods: {
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    changeAudio(_name) {
      // console.log('CLICK');
      let name = _name;
      if (!name) {
        name = _.sample(AUDIO_NAMES);
      }
      return getAudioURL(name).then((audioURL) => {
        this.audioFile = audioURL;
        this.forceRerender();
      });
    },
    forceRerender() {
      this.componentKey = !this.componentKey;
    },
    setSource(src) {
      this.player.source = {
        type: 'audio',
        sources: [
          {
            src: require(`__staticDir/${this.$store.getters.multibookType}/${src}`),
            type: 'audio/mp3',
          },
          {
            src: require(`__staticDir/${this.$store.getters.multibookType}/${src}`),
            type: 'audio/ogg',
          },
        ],
      };
    },
  },
  beforeDestroy() {
    console.log('Destroy Plyr audio');
    this.$store.commit('GALLERY_DEACTIVATE');
    this.destroyAudio = true;
  },
  computed: {
    audio() {
      return this.$store.getters.audioData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-img {
  position: fixed;
  object-fit: cover;
}
.audio-wraper {
  position: absolute;
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  .audio {
    display: block;
    width: 40vw;
    height: auto;
    margin-bottom: 30px;
    // position: relative;
    #playerAudio {
      width: 100%;
    }
    .audio-title {
      padding-top: 1vmin;
      padding-bottom: 1vmin;
      font-size: 3vmin;
      z-index: 17;
    }
  }
}
#magic-button {
  pointer-events: auto;
}
/**change base white color to light grey */
.plyr--audio .plyr__controls {
  background: #e6e6e6 !important;
}
.plyr__menu__container {
  background: rgba(#e6e6e6, 0.9);
}
</style>
